module.exports = "https://web-assets.ifttt.com/packs/media/icons/feed_applet_indicator_arrow-97505530.png";